import script from "./PullToRefresh.vue?vue&type=script&setup=true&lang=ts"
export * from "./PullToRefresh.vue?vue&type=script&setup=true&lang=ts"

import "./PullToRefresh.vue?vue&type=style&index=0&id=efa7254c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efa7254c"]])

export default __exports__